exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filter-search {\n  min-height: 0;\n}\n.filter-search__input {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  width: unset;\n}\n", ""]);

